import { useState } from "react";

const useTabs = (initialTab: number) => {
  const [selectedTab, setSelectedTab] = useState(initialTab);

  const handleTabChange = (tab: number) => {
    setSelectedTab(tab);
  };

  return { selectedTab, handleTabChange };
};

export default useTabs;
